
import { CellError, ErrorType } from '../../Cell';
import { ErrorMessage } from '../../error-message';
import { FunctionPlugin } from '../index';
import { FunctionArgumentType } from './FunctionPlugin';
export class FormulaTextPlugin extends FunctionPlugin {
    /**
     * Corresponds to FORMULATEXT(value)
     *
     * Returns a formula in a given cell as a string.
     *
     * @param ast
     * @param state
     */
    formulatext(ast, state) {
        return this.runFunctionWithReferenceArgument(ast.args, state, this.metadata('FORMULATEXT'), () => new CellError(ErrorType.NA, ErrorMessage.WrongArgNumber), (cellReference) => { var _a; return (_a = this.serialization.getCellFormula(cellReference)) !== null && _a !== void 0 ? _a : new CellError(ErrorType.NA, ErrorMessage.Formula); });
    }
}
FormulaTextPlugin.implementedFunctions = {
    'FORMULATEXT': {
        method: 'formulatext',
        parameters: [
            { argumentType: FunctionArgumentType.NOERROR }
        ],
        doesNotNeedArgumentsToBeComputed: true,
        isDependentOnSheetStructureChange: true,
        vectorizationForbidden: true,
    },
};
